import { render } from "./AppButtonAction.vue?vue&type=template&id=beafc6e2&scoped=true&ts=true&lang=pug"
import script from "./AppButtonAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppButtonAction.vue?vue&type=script&lang=ts&setup=true"

import "./AppButtonAction.vue?vue&type=style&index=0&id=beafc6e2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beafc6e2"]])

export default __exports__